module.exports = ".product-summary p {\n  margin-bottom: 10px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Styles/profile.scss
// module id = ./src/app/Styles/profile.scss
// module chunks = main